(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/utils/lotto-utils.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/utils/lotto-utils.js');
"use strict";

let config;
let productMapping;
if (svs.isServer) {
  var _trinidadCore$config$;
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  ({
    productMapping
  } = trinidadCore.components.require('numbergames', 'product-mapping'));
  config = (_trinidadCore$config$ = trinidadCore.config.options.cms) === null || _trinidadCore$config$ === void 0 ? void 0 : _trinidadCore$config$.numbergames;
} else {
  var _svs$numbergames$rule;
  ({
    productMapping
  } = svs.numbergames);
  config = (_svs$numbergames$rule = svs.numbergames.rules.data) === null || _svs$numbergames$rule === void 0 ? void 0 : _svs$numbergames$rule.config;
}
const isNewRules = _ref => {
  var _config$lotto$ruleCha, _config;
  let {
    drawNumber,
    product
  } = _ref;
  if (!drawNumber || !product) {
    return false;
  }
  const {
    ONSLOTTO,
    LORLOTTO
  } = (_config$lotto$ruleCha = (_config = config) === null || _config === void 0 || (_config = _config.lotto) === null || _config === void 0 ? void 0 : _config.ruleChange) !== null && _config$lotto$ruleCha !== void 0 ? _config$lotto$ruleCha : {};
  if (!ONSLOTTO || !LORLOTTO) {
    return false;
  }
  switch (true) {
    case productMapping.isLottoWednesday(product) && drawNumber >= ONSLOTTO:
    case productMapping.isLottoSaturday(product) && drawNumber >= LORLOTTO:
      return true;
    default:
      return false;
  }
};
const getRuleChangeDrawNumber = product => {
  var _config$lotto$ruleCha2, _config2;
  const {
    ONSLOTTO,
    LORLOTTO
  } = (_config$lotto$ruleCha2 = (_config2 = config) === null || _config2 === void 0 || (_config2 = _config2.lotto) === null || _config2 === void 0 ? void 0 : _config2.ruleChange) !== null && _config$lotto$ruleCha2 !== void 0 ? _config$lotto$ruleCha2 : {};
  switch (true) {
    case productMapping.isLottoWednesday(product):
      return ONSLOTTO;
    case productMapping.isLottoSaturday(product):
      return LORLOTTO;
    default:
      svs.numbergames.rules.logger.debug('getRuleChangeDrawNumber: missing params');
  }
};
const getIsRuleChangePeriod = _ref2 => {
  var _config$lotto$ruleCha3, _config3;
  let {
    firstDraw,
    lastDraw,
    product
  } = _ref2;
  const {
    ONSLOTTO,
    LORLOTTO
  } = (_config$lotto$ruleCha3 = (_config3 = config) === null || _config3 === void 0 || (_config3 = _config3.lotto) === null || _config3 === void 0 ? void 0 : _config3.ruleChange) !== null && _config$lotto$ruleCha3 !== void 0 ? _config$lotto$ruleCha3 : {};
  if (!firstDraw || !lastDraw || !product || !ONSLOTTO || !LORLOTTO) {
    svs.numbergames.rules.logger.debug('isRuleChangePeriod: missing params');
    return false;
  }
  switch (true) {
    case productMapping.isLottoWednesday(product) && firstDraw < ONSLOTTO && lastDraw >= ONSLOTTO:
    case productMapping.isLottoSaturday(product) && firstDraw < LORLOTTO && lastDraw >= LORLOTTO:
      return true;
    default:
      return false;
  }
};
function showRuleChangeInfo(_ref3) {
  let {
    firstDraw,
    lastDraw,
    product,
    numDrawsOverChange = 10
  } = _ref3;
  const ruleChangeDrawNum = getRuleChangeDrawNumber(product);
  const isRuleChangePeriod = getIsRuleChangePeriod({
    firstDraw,
    lastDraw,
    product
  });
  return firstDraw >= ruleChangeDrawNum && firstDraw <= ruleChangeDrawNum + numDrawsOverChange || isRuleChangePeriod;
}
if (svs.isServer) {
  module.exports = {
    isNewRules,
    showRuleChangeInfo
  };
} else {
  Object.assign(svs.numbergames.rules.utils.lotto, {
    isNewRules,
    showRuleChangeInfo
  });
}

 })(window);